// Primary Brand Colors
export const PRIMARY_ORANGE = {
    main: '#FE6A2E',
    light: '#FF8F5A',
    dark: '#E5511A',
    darker: '#CC4410',
} as const;

// Solid Color Definitions (no gradients)
export const COLORS = {
    primary: '#FE6A2E',
    primaryHover: '#E5511A',
    primaryLight: '#FF8F5A',
    primaryDark: '#CC4410',
} as const;

// Light Mode Colors
export const LIGHT_THEME = {
    background: '#f8fafc',
    cardBackground: 'rgba(255, 255, 255, 0.9)',
    textPrimary: '#1f2937',
    textSecondary: '#6b7280',
    inputBackground: 'rgba(249, 250, 251, 0.9)',
    chatAssistantBg: 'rgba(245, 245, 245, 0.9)',
    borderColor: 'rgba(209, 213, 219, 0.4)',
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    navBackground: 'rgba(255, 255, 255, 0.95)',
    navShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
    hoverBackground: 'rgba(255, 255, 255, 0.95)',
    cardHoverShadow: '0 12px 40px 0 rgba(0, 0, 0, 0.15)',
    buttonDisabled: 'rgba(200, 200, 200, 0.5)',
    buttonDisabledHover: 'rgba(180, 180, 180, 0.6)',
    fieldHover: '1px solid rgba(0, 0, 0, 0.2)',
    iconHover: 'rgba(0, 0, 0, 0.05)',
} as const;

// Dark Mode Colors
export const DARK_THEME = {
    background: '#0a0a0a',
    cardBackground: 'rgba(40, 40, 40, 0.8)',
    textPrimary: '#ffffff',
    textSecondary: '#d1d5db',
    inputBackground: 'rgba(60, 60, 60, 0.9)',
    chatAssistantBg: 'rgba(50, 50, 50, 0.9)',
    borderColor: 'rgba(100, 100, 100, 0.3)',
    shadowColor: 'rgba(0, 0, 0, 0.5)',
    navBackground: 'rgba(26, 26, 26, 0.95)',
    navShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    hoverBackground: 'rgba(60, 60, 60, 0.9)',
    cardHoverShadow: '0 12px 40px 0 rgba(0, 0, 0, 0.4)',
    buttonDisabled: 'rgba(100, 100, 100, 0.3)',
    buttonDisabledHover: 'rgba(120, 120, 120, 0.4)',
    fieldHover: '1px solid rgba(255, 255, 255, 0.3)',
    iconHover: 'rgba(255, 255, 255, 0.1)',
    inputAreaBackground: 'rgba(26, 26, 26, 0.9)',
} as const;

// Common Shadow Definitions
export const SHADOWS = {
    primary: '0 4px 16px 0 rgba(254,106,46,0.2)',
    primaryStrong: '0 4px 16px 0 rgba(254,106,46,0.3)',
    primaryHover: '0 6px 20px 0 rgba(254,106,46,0.4)',
    card: '0 8px 32px 0',
} as const;

// Focus States
export const FOCUS = {
    border: '2px solid #FE6A2E',
    color: '#FE6A2E',
} as const;

// Common Opacity Values
export const OPACITY = {
    disabled: 0.5,
    secondary: 0.7,
    subtle: 0.8,
} as const; 